import i18n from 'i18next'
import errorCodeToMessage from 'network/messages/errorCodeMessages'
import errorMessages from 'network/messages/errorMessages'

/**
 * function which translate any text into user selected language
 * @param {string} text - text which need to translate
 * @param {object} [options] - i18next interpolation / options
 * @returns translated text
 */
export const getTranslation = (text, options) => i18n.t(text, options)

/**
 * function which convert error code into translated error message
 * @param {number} errorCode - ErrorCode which is obtained from api response error
 * @returns { string } translated Error Message
 */
export const getTranslatedErrorMessage = (errorCode) => {
  const errorMessage =
  errorCodeToMessage.get(errorCode) || errorMessages.internalServerError
  return getTranslation(errorMessage)
}
